module.exports = __webpack_public_path__ + "media/fonts/Matter-Light-e3a8345e544bdb2a943ff6c7b2efa8ce.ttf";